import styled from 'styled-components';

const ReviewContainer = styled.div`
  background: #f8f8f8;
  border-radius: 4px;
  width: 75%;

  > h4 {
    font-weight: bold;
    color: ${({ theme }) => theme.grey.dark};
    font-size: ${({ theme }) => theme.fontSize.md};
  }

  > p,
  > span {
    font-weight: normal;
    line-height: 1.4;
  }
`;

const SignatureContainer = styled.div`
  margin-top: 30px;
  display: flex;
  font-size: ${({ theme }) => theme.fontSize.xs};
  align-items: center;
  > div {
    position: relative;
  }

  & small {
    margin-right: 10px;
  }
`;
const Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
const Wrapper = styled(Flex)`
  align-items: stretch;
  padding-top: 30px;
  margin: 0 16px 20px 16px;
  padding: 26px 29px;
  background: #f8f8f8;
  width: 100%;
`;

export default ReviewContainer;
export { ReviewContainer, SignatureContainer, Flex, Wrapper };
